import fetchApi from "../../../lib/fetchApi";
import { downloadCsvFile } from "../../../utils/downloadCsvFile";
import { formatDateToCompactYYYYMMDD } from "../../../utils/formatters/DateFormatter";
import { ClaimHistoricCSVRequestDto } from "../types";


const BASE_URL = "/claim"

export const exportCsvClaim = async (body: ClaimHistoricCSVRequestDto): Promise<void> => {
    try {
        const response = await fetchApi.post<ArrayBuffer>(`${BASE_URL}/exportCSV`, body, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        let arrayBufferData = response;
        if (!arrayBufferData) {
            // Maybe it's directly in response?
            if (response instanceof ArrayBuffer) {
                arrayBufferData = response;
            }
        }

        if (!arrayBufferData) {
            throw new Error('No ArrayBuffer data found in response');
        }

        const defaultFilename = 'craiteria_historical'; // Base name

        // Combine base name, date, and user input if any
        const finalFilename = `${defaultFilename}_${formatDateToCompactYYYYMMDD()}.csv`;
        downloadCsvFile(arrayBufferData, finalFilename);
    } catch (error) {
        console.error('Error downloading CSV:', error);
        throw error;
    }
};